import { Api } from "./api";
import {
  BibleSiteStorable,
  BibleSiteGettable
} from "./typedefs/BibleSiteStorage";
import { Downloader } from "./downloader";
import { IndexedDb } from "./indexeddb";
import { OfflineState } from "./typedefs/BibleOffline";
import {
  AUTHN_PROBLEM,
  AUTHZ_PROBLEM,
  CACHED,
  FAILURE,
  failure,
  LATER,
  LOCAL,
  NEVER,
  NOT_FOUND,
  QUEUED,
  retry,
  statusFromHttp,
  statusType,
  SUCCESS,
  success
} from "./typedefs/RequestStatus";

export {
  AUTHN_PROBLEM,
  AUTHZ_PROBLEM,
  CACHED,
  FAILURE,
  failure,
  LATER,
  LOCAL,
  NEVER,
  NOT_FOUND,
  OfflineState,
  QUEUED,
  retry,
  statusFromHttp,
  statusType,
  SUCCESS,
  success
};

let _globalBibleSource: Downloader | undefined = undefined;

async function initBibleSource(): Promise<Downloader> {
  // By default, no cache and no Scripture data source
  let storage: BibleSiteStorable | undefined = undefined; // by default, no caching
  let sources: BibleSiteGettable[] = [];

  // Add the Scripture API as a data source
  const api = new Api(
    window.fetch.bind(window), // this is an easy thing to mess up: fetch() HAS to be bound in the browser.
    process.env.REACT_APP_BIBLE_API_KEY || "provide a key for api.bible",
    process.env.REACT_APP_BIBLE_API || "https://api.scripture.api.bible/v1/",
    process.env.REACT_APP_SITE_API || "https://api.global.bible/"
  );
  console.debug("adding Bible source: api.bible");
  sources.push(api);

  // If building a PWA, add a caching layer
  // This clause is written to play well with dead code elimination,
  // but CRA currently doesn't support that.
  if (process.env.REACT_APP_BUILD_TARGET === "PWA") {
    if (IndexedDb.capable()) {
      console.debug("adding Bible cache: IndexedDb");
      const db = new IndexedDb("bible-sites");
      await db.open();
      storage = db;
    } else {
      console.debug(
        "not adding Bible cache: IndexedDb not supported on client"
      );
    }
  } else {
    console.debug("not adding Bible cache: not a PWA build");
  }

  // COULDDO: add the Cordova layer

  const cache = new Downloader(storage, sources);
  cache.start();
  return cache;
}

// bibleSource ensures the global bible data source is opened and
// has it's queue started (if it has one).
export async function bibleSource(): Promise<Downloader> {
  if (!_globalBibleSource) {
    _globalBibleSource = await initBibleSource();
  }
  return _globalBibleSource;
}
